export default __webpack_public_path__ + "static/media/chatbot-recipient-mapping-screenshot.c58d51c5.png";